"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    INDENT: "  ",
    MARGIN: "　",
    EOL: "\r\n",
};
//# sourceMappingURL=toCSTSettings.js.map